<template>

    <div class="container-fluid" style="padding: 0px; overflow: hidden;">
        <div class="row">
            <div class="col">
                <div class="hero_banner">
                    <h2>Sleep Health Screener</h2>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-5 py-4 container about_top">
        <div class="justify-content-center row">
            <div class="col-lg-6 col-md-8">
                <div class="text-left">
                    <p class="text-muted mb-4">The Sleep Health Screener (SDSCL-25) is designed to identify whether or
                        not you are positive for (experience) any signs or symptoms of 13 sleep disorders.</p>
                    <p>While comprehensive, the survey is brief (takes 3-5 minutes) and is provided at no cost.</p>
                    <p class="mb-4">When you have completed the screener, the results will be available to you:</p>
                    <ul class="list-unstyled mb-4">
                        <li>1. As a downloadable PDF of your completed survey;</li>
                        <li>2. In a report format that can be saved/printed as PDF;</li>
                        <li>3. As an email that has a copy of your completed survey and report.</li>
                    </ul>
                    <p>These documents can be shared with your primary care clinician or a sleep health specialist.</p>
                    <p class="text-muted">Once you complete the survey, your identifying information will be discarded.
                    </p>
                    <div class="button_wrapper d-flex justify-content-left mt-5">
                        <a href="https://www.youtube.com/watch?v=U-e8QIczRt0" target="_blank"
                            class="MuiButton-contained">For further information (a video) click HERE</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="founders" class="home_main_sec "
        style="padding-top: 50px; padding-bottom: 70px; margin-top: 50px; background-color: rgb(241, 241, 241);">
        <div class="py-4 container">
            <div class="text-center mb-5">
                <h2 class="main_head mb-5">About the doctors</h2>
            </div>
            <div class="g-4 justify-content-center row">
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                    <div class="h-100 shadow-sm card">
                        <img class="card-img-top rounded-top" src="@/assets/MichaelPerlis.jpg" alt="Dr. Michael Perlis">
                        <div class="card-body">
                            <div class="fw-bold text-dark card-title h5">Dr. Michael Perlis</div>
                            <p class="small card-text">Associate Professor of Psychiatry and Director, Behavioral Sleep
                                Medicine Program, University of Pennsylvania Perelman School of Medicine</p>
                            <div class="social-icons">
                                <a href="https://www.linkedin.com/in/michael-perlis-503a236a/" target="_blank">
                                    <i class="fab fa-linkedin"></i>
                                </a>
                                <a href="http://www.michaelperlis.com" target="_blank">
                                    <i class="fas fa-globe"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                    <div class="h-100 shadow-sm card">
                        <img class="card-img-top rounded-top" src="@/assets/MichaelGrandner.jpg"
                            alt="Dr. Michael Grandner">
                        <div class="card-body">
                            <div class="fw-bold text-dark card-title h5">Dr. Michael Grandner</div>
                            <p class="small card-text">Associate Professor of Psychiatry and Director, Sleep and Health
                                Research Program, University of Arizona College of Medicine</p>
                            <div class="social-icons">
                                <a href="https://www.linkedin.com/in/grandner/" target="_blank">
                                    <i class="fab fa-linkedin"></i>
                                </a>
                                <a href="http://www.michaelgrandner.com" target="_blank">
                                    <i class="fas fa-globe"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                    <div class="h-100 shadow-sm card">
                        <img class="card-img-top rounded-top" src="@/assets/DonnPosner.jpg" alt="Dr. Donn Posner">
                        <div class="card-body">
                            <div class="fw-bold text-dark card-title h5">Dr. Donn Posner</div>
                            <p class="small card-text">CEO, SleepWell Consultants, Previously on faculty at Stanford
                                University and Brown University</p>
                            <div class="social-icons">
                                <a href="https://www.linkedin.com/in/donn-posner-128b7792/" target="_blank">
                                    <i class="fab fa-linkedin"></i>
                                </a>
                                <a href="http://www.sleepwellconsultants.com" target="_blank">
                                    <i class="fas fa-globe"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="max_width_1240_mauto mt-5 container">
        <div class="row">
            <div class="col">
                <div class="qrcode_wrapper d-flex">
                    <img src="@/assets/sleep_health_qr_code.png" alt="Qrcode">
                    <router-link class="MuiButton-contained green" to="/sleephealthscreen/terms-condition">Start My
                        Sleep
                        Assessment</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: 'AboutPage',
    components: {
    },

};
</script>

<style scoped>
.social-icons {
    display: flex;
    gap: 20px;
    font-size: 25px;
}

.MuiButton-contained.green {
    background-color: green;
}

.MuiButton-contained.green:hover {
    background-color: green;
}

.button_wrapper {
    justify-content: flex-start;
}

.about_top p {
    font-size: 18px;
}

.about_top ul li {
    font-size: 18px;
}

#founders .container {
    max-width: 1000px;
}

#founders .card-img-top {
    max-height: 350px;
    object-fit: cover;
    object-position: top;
    min-height: 350px;
}

.hero_banner {
    background-image: url(../assets/description_banner.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 200px;
    box-shadow: inset 0 0 0 1000px rgb(0 0 0 / 35%);
    display: flex;
    justify-content: center;
    align-items: center;
}

.hero_banner h2 {
    color: #ffffff;
    font-size: 40px;
}

@media screen and (max-width: 767px) {

    .terms_banner h2,
    .hero_banner h2 {
        font-size: 30px;
        text-align: center;
    }

    .hero_banner {
        height: 150px;
    }
}
</style>